import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DssService from "services/dssService";

export const initialState = {
  list: [],
  loading: false,
  errorMessages: [],
  showMessage: false,
};

export const fetchDss = createAsyncThunk(
  "/fetchDss",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await DssService.fetch(queryParams);
      var code = response.code;
      return {
        code: code,
        dssList: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const DssSlice = createSlice({
  name: "dss",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDss.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDss.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.dssList;
      })
      .addCase(fetchDss.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = DssSlice.actions;

export default DssSlice.reducer;
